import React from 'react';
import './Terms.css';
import { Link } from 'react-router-dom';

const Terms = () => {
    return (
        <div className="privacy-container">
            <h1>TÉRMINOS Y CONDICIONES</h1>
            {/* <p><strong>Fecha de última actualización:</strong> [Fecha]</p> */}

            <h2>1. Introducción</h2>
            <p>
                Bienvenido a la aplicación y sitio web de reproducción de la radio online de <strong>Embajadores Stereo</strong> (en adelante, “el Servicio”). El acceso y uso del Servicio se rige por los presentes Términos y Condiciones, que establecen los derechos y obligaciones entre <strong>Embajadores Stereo</strong> y los usuarios (en adelante, “el Usuario” o “los Usuarios”). Al utilizar nuestro Servicio, aceptas de forma expresa y sin reservas estos términos.
            </p>

            <h2>2. Objeto del Servicio</h2>
            <p>
                El Servicio tiene como finalidad brindar acceso a contenido de radio online, permitiendo a los Usuarios escuchar transmisiones en vivo y/o contenido relacionado con las actividades y eventos de <strong>Embajadores Stereo</strong>. El Servicio podrá incluir, de manera ocasional, información adicional, actualizaciones, noticias y contenido multimedia, de acuerdo con las políticas internas de la organización.
            </p>

            <h2>3. Aceptación y Modificaciones</h2>
            <p>
                <strong>Aceptación:</strong> Al acceder y/o utilizar el Servicio, manifiestas tu conformidad con estos Términos y Condiciones, así como con la Política de Privacidad que forma parte integral del mismo.
            </p>
            <p>
                <strong>Modificaciones:</strong> <strong>Embajadores Stereo</strong> se reserva el derecho de modificar, actualizar o eliminar, total o parcialmente, los presentes Términos y Condiciones en cualquier momento. Se recomienda a los Usuarios revisar periódicamente este documento para estar informados de cualquier cambio. El uso continuado del Servicio después de la publicación de modificaciones implicará la aceptación de los cambios realizados.
            </p>

            <h2>4. Acceso y Uso del Servicio</h2>
            <p>
                <strong>Requisitos de Uso:</strong> El acceso al Servicio es gratuito. Para ciertos contenidos o funcionalidades, es posible que se requiera la creación de una cuenta de usuario, cuyo registro implicará la veracidad y actualización de la información proporcionada.
            </p>
            <p>
                <strong>Uso Adecuado:</strong> El Usuario se compromete a utilizar el Servicio de manera lícita, respetando los derechos de terceros y absteniéndose de realizar acciones que puedan dañar, interrumpir o sobrecargar la infraestructura del Servicio o interferir en el normal funcionamiento del mismo.
            </p>
            <p>
                <strong>Prohibiciones:</strong> Queda terminantemente prohibido:
            </p>
            <ul>
                <li>Utilizar el Servicio con fines ilícitos o fraudulentos.</li>
                <li>Distribuir, reproducir, modificar o transformar cualquier contenido sin la debida autorización.</li>
                <li>Realizar actividades que puedan dañar la reputación o integridad de <strong>Embajadores Stereo</strong> o de terceros.</li>
            </ul>

            <h2>5. Propiedad Intelectual e Industrial</h2>
            <p>
                <strong>Contenido Propio:</strong> Todos los derechos de propiedad intelectual e industrial sobre los contenidos, logotipos, diseños, gráficos, textos, imágenes, sonido y demás elementos que componen el Servicio son titularidad de <strong>Embajadores Stereo</strong> o de terceros que han autorizado su uso.
            </p>
            <p>
                <strong>Uso Limitado:</strong> Queda prohibida la reproducción, distribución, comunicación pública, transformación o cualquier otra forma de explotación de los contenidos del Servicio sin la autorización expresa y por escrito de <strong>Embajadores Stereo</strong>, salvo en los casos en que la ley autorice expresamente dicha utilización.
            </p>

            <h2>6. Responsabilidad y Limitación de Responsabilidad</h2>
            <p>
                <strong>Exactitud y Disponibilidad:</strong> <strong>Embajadores Stereo</strong> se esfuerza por ofrecer un Servicio de calidad y con información actualizada, pero no garantiza la continuidad, disponibilidad o ausencia de errores en el Servicio. La utilización del Servicio es bajo el propio riesgo del Usuario.
            </p>
            <p>
                <strong>Limitación:</strong> En ningún caso <strong>Embajadores Stereo</strong> será responsable por daños directos, indirectos, incidentales, consecuentes o especiales que se deriven del uso o la imposibilidad de uso del Servicio, incluyendo, sin limitación, pérdidas de ingresos, datos o interrupciones del negocio.
            </p>
            <p>
                <strong>Contenido de Terceros:</strong> El Servicio puede incluir enlaces o referencias a sitios web o contenidos de terceros. <strong>Embajadores Stereo</strong> no asume responsabilidad alguna sobre la veracidad, precisión o calidad de dichos contenidos o la legalidad de su uso.
            </p>

            <h2>7. Política de Privacidad</h2>
            <p>
                El tratamiento de los datos personales de los Usuarios se rige por nuestra <Link to="/privacy">Política de Privacidad</Link>, la cual se integra en el presente documento por referencia. Te recomendamos leerla detenidamente para conocer cómo se recaban, utilizan y protegen tus datos.
            </p>

            <h2>8. Duración y Terminación</h2>
            <p>
                <strong>Duración:</strong> Estos Términos y Condiciones entran en vigor a partir del momento en que el Usuario accede y utiliza el Servicio.
            </p>
            <p>
                <strong>Terminación:</strong> <strong>Embajadores Stereo</strong> se reserva el derecho de suspender o terminar el acceso de cualquier Usuario que incumpla los presentes Términos y Condiciones, sin necesidad de previo aviso.
            </p>

            <h2>9. Legislación Aplicable y Jurisdicción</h2>
            <p>
                Estos Términos y Condiciones se rigen por la legislación colombiana. Para la resolución de cualquier controversia que pudiera derivarse del acceso o uso del Servicio, las partes se someten a la jurisdicción de los tribunales competentes de Chinú, Córdoba, Colombia, renunciando expresamente a cualquier otro fuero que pudiera corresponderles.
            </p>

            <h2>10. Contacto</h2>
            <p>
                Si tienes preguntas, comentarios o necesitas mayor información sobre estos Términos y Condiciones, por favor contáctanos a través de:
            </p>
            <ul>
                <li><strong>Correo electrónico:</strong> contacto@embajadoresdelgranrey.com</li>
                <li><strong>Dirección:</strong> Cl. 24 #9-91, Chinú, Córdoba</li>
                {/* <li><strong>Teléfono:</strong> [Número de contacto]</li> */}
            </ul>

            <p>
                <em>
                Este documento es un ejemplo orientativo y no constituye asesoramiento legal. Se recomienda consultar con un profesional del derecho para adaptarlo a las particularidades de tu servicio y garantizar el cumplimiento normativo.
                </em>
            </p>
        </div>
    );
};

export default Terms;
